export const GET_DB_HEALTH_CHECK_REQUEST = "GET_DB_HEALTH_CHECK_REQUEST";
export const GET_DB_HEALTH_CHECK_SUCCESS = "GET_DB_HEALTH_CHECK_SUCCESS";
export const GET_DB_HEALTH_CHECK_FAILURE = "GET_DB_HEALTH_CHECK_FAILURE";
